class ContactusController {
  constructor ($http) {
    this.$http = $http;
    this.form = {};
    this.sended = false;
  }
  send () {

      this.$http.get('/Home.aspx/EmailUS', {
          params: {
              name: this.form.name,
              phone: this.form.phone,
              email: this.form.email,
              question: this.form.question
          }
      });
      
      this.sended = true;

  }
}

ContactusController.$inject = ['$http'];

export {ContactusController};



/** WEBPACK FOOTER **
 ** ./src/app/components/contactus/contactus.controller.js
 **/